<template>
  <div class="menu">
    <el-menu :default-active="route.path" unique-opened>
      <template v-for="menu in menuRoutes">
        <template v-if="menu.meta?.title">
          <el-sub-menu
            :index="menu.path"
            v-if="menu.children?.length"
          >
            <template #title>
              <SvgIcon
                :name="menu.meta.icon"
                class="icon-size"
                v-if="menu.meta.icon"
              ></SvgIcon>
              <span class="title">&nbsp;&nbsp;{{ menu.meta.title }}</span>
            </template>
            <el-menu-item
              :index="child.path"
              v-for="child in menu.children"
              @click="to(child.path)"
              :class="{
                'is-active': $route.path === child.path, // 子级高亮
              }"
            >
              <el-tooltip
                v-if="child.meta.title.length > 9"
                :content="child.meta.title"
                placement="right"
              >
                <div class="title sub-title">
                  <SvgIcon
                    name="line"
                    class="line"
                    :color="child.path === $route.path ? '#fff' : '#10b884'"
                  />
                  <span>{{ child.meta.title }}</span>
                </div>
              </el-tooltip>
              <span v-else class="title sub-title">
                <SvgIcon
                  name="line"
                  class="line"
                  :color="child.path === $route.path ? '#fff' : '#10b884'"
                />
                <span>{{ child.meta.title }}</span>
              </span>
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item :index="menu.path" v-else @click="to(menu.path)">
            <SvgIcon
              v-if="menu.meta.icon"
              :name="menu.meta.icon"
              class="icon-size"
            ></SvgIcon>
            <span class="title">&nbsp;&nbsp;{{ menu.meta.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";
import { session } from "@/utils/storage.js";
import SvgIcon from "@/components/Global/SvgIcon.vue";

const router = useRouter();
const route = useRoute();
const menuRoutes = session.get("routes");

const to = (path) => {
  router.push(path);
};

</script>

<style scoped lang="scss">
* {
  user-select: none;
}
.icon-size {
  width: 24px !important;
  height: 24px !important;
}

:deep() {
  --el-menu-text-color: #6fcaf7;
  --el-menu-hover-bg-color: transparent;
  .el-menu-item {
    border: none;
    background: url("@/assets/svgs/select.svg#svgView(preserveAspectRatio(none))") no-repeat center center;
    background-size: 100% 100%;
    &.is-active {
      background: url("@/assets/svgs/select_check.svg#svgView(preserveAspectRatio(none))") no-repeat center center;
      background-size: 100% 100%;
      color: #fff !important;
    }
  }
  .el-sub-menu__title {
    border: none;
    background: url("@/assets/svgs/select.svg#svgView(preserveAspectRatio(none))") no-repeat center center;
    background-size: 100% 100%;
  }
  .el-sub-menu .el-menu {
    border: none;
    background: none;
  }
  .el-sub-menu .el-menu-item {
    height: var(--el-menu-item-height);
    line-height: var(--el-menu-item-height);
  }
}
.menu {
  position: relative;
  .el-menu {
    border: none;
    background: none;
  }
}
.title {
  flex: 1;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  width: 120px;
  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
